import { render, staticRenderFns } from "./BaseCSVDownloadBtn.vue?vue&type=template&id=13d10ebd&scoped=true&"
import script from "./BaseCSVDownloadBtn.vue?vue&type=script&lang=ts&"
export * from "./BaseCSVDownloadBtn.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCSVDownloadBtn.vue?vue&type=style&index=0&id=13d10ebd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d10ebd",
  null
  
)

export default component.exports